const getters = {
    getUsers: state => state.users,
    isSave: state => state.successfullysave,
    hasErrorInService: state => state.hasErrorInService,
    getUser: state => state.user
}

export default getters